var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"farms-page"},[_c('FarmHeader',{staticClass:"mb-2 mt-4",attrs:{"search":_vm.search,"finished":_vm.finished,"hideCreateNew":true},on:{"update:search":function($event){_vm.search=$event},"update:finished":function($event){_vm.finished=$event}}}),_c('FarmsTableNew',{attrs:{"farmPools":_vm.farmPools,"finished":_vm.finished}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }